// extracted by mini-css-extract-plugin
module.exports = {"total":"total--1BTRe","total__value":"total__value--1P2Sw"};